import React, { useState } from 'react';
import dataset from "./Data.json"
import song from "./Song.json"

const category = [
  {
    "name": "消极负面",
    "id": 6
  },
  {
    "name": "涉黄",
    "id": 0
  },
  {
    "name": "脏话谩骂",
    "id": 4
  },
  {
    "name": "涉暴",
    "id": 2
  },
  {
    "name": "涉政",
    "id": 3
  },
  {
    "name": "宗教信仰",
    "id": 5
  },
  {
    "name": "烟酒毒",
    "id": 1
  },
  {
    "name": "其他",
    "id": 7
  },
]

const path = process.env.PUBLIC_URL

const Data = () => {
  const [currentSong, setCurrentSong] = useState(0);
  const [currentLine, setCurrentLine] = useState(0);
  const [currentShow, setCurrentShow] = useState(null);
  const [hint, setHint] = useState(true);

  function wrapInSpan(stringA, stringB, stringC, id) {
    var start = stringB.indexOf(stringA);
    var end = start + stringA.length;
    var newStringB = stringB.substring(0, start) + "<s id='" + id + "'>" + stringB.substring(start, end) + "</s><br/><span>" + stringC + "</span>" + stringB.substring(end);
    return newStringB;
  }

  return (
    <div className="relative self-start mb-[15vh] h-[100%]">
      <div className="data intro__container h-[100%]">
        <h2><span>敏感词分类</span></h2>
        <div className="absolute right-9 top-10 z-10">
          <button className={"font-bold text-[14px] border-[3px] border-ink mr-[-3px] px-2 py-1 rounded-tl-md rounded-bl-md " + (currentShow === 0 ? "bg-red" : "bg-green")} onClick={() => setCurrentShow(0)}>乐夏</button>
          <button className={"font-bold text-[14px] border-[3px] border-ink bg-green px-2 py-1 rounded-tr-md rounded-br-md " + (currentShow === 1 ? "bg-red" : "bg-green")} onClick={() => setCurrentShow(1)}>浪姐</button>
        </div>
        <div className="mt-[-50px] max-w-[500px] w-full scrollbar-hide overflow-y-scroll whitespace-nowrap h-[100%] rounded-[20px]">
          <div className="bg-ink pt-[12%] md:pt-[15%] pb-[8%] px-6 p-2 rounded-[20px]">
          {category.map((item, index) => (
            <div>
              <span className="text-white">{item.name}</span>
              <div className="mb-2 flex flex-wrap">
              {dataset.filter(data => data.category === item.id).sort((a, b) => a.show > b.show ? 1 : -1).map((child, idx) => (
                <button id={child.id} onClick={() => {setCurrentSong(child.songId); setCurrentLine(child.id); setHint(false);}} className={"w-[10px] h-[12px] inline-block mr-1 mb-[2px] mt-1 " + (index === 0 && idx === 12 && hint ? "hint " : " ") + (child.show === currentShow ? "bg-red" : "bg-green")}></button>
              ))}
              </div>
            </div>
          ))}
          </div>
        </div>
        {/* <img src={`${path}/images/eye2.svg`} className="absolute w-[120px] bottom-[-5px] left-[50%] z-10 translate-x-[-50%]" /> */}
      </div>
      <div className="absolute left-0 top-0 w-full h-full pointer-events-none flex justify-center align-middle px-3 py-3">
        {song.map((sData, index) => (
          <div className={"p-4 relative top-0 w-full h-full bg-[#F8F1E8] rounded-[20px] pointer-events-auto z-[110] " + (sData.songId === currentSong ? "block" : "hidden")}>
            <div className="text-[20px] font-black mb-4">
              {sData.name}<br/>
              <span className='text-[16px] font-medium inline-block w-[calc(100%_-_20px)]'>演唱: {sData.performer}</span>
            </div>
            <div className="h-[calc(100%_-_80px)] overflow-scroll">
              {dataset.filter(data => data.songId === sData.songId).map((child, idx) => (
                <div dangerouslySetInnerHTML={{ __html: wrapInSpan(child.before, sData.before, child.after, child.id) }} className={"whitespace-pre-line fullLyrics text-grey " + (child.id === currentLine ? "block" : "hidden")}  />
              ))}
              <br/>
              <div className="text-[16px] font-medium mb-4">
                作词: {sData.writer}<br/>
                唱片公司: {sData.company}
              </div>
            </div>
            <button onClick={() => setCurrentSong(0)} className="absolute top-4 right-4 text-red text-[45px] leading-[1]">✘</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Data;